import axios from 'axios'
import { BUSCAR_FECHAMENTO_CAIXA } from '../../types'
import { SLOW_REQUEST_CONFIG } from '../../../util/loadingUtil'
import { URL } from '../../../util/ambienteActions';

export default function buscarFechamentoCaixa(idEmpresa, idUsuarioEmpresa, data, id) {
  let url = `${URL}/fechamento-caixa-usuario/empresa/${idEmpresa}/usuarioEmpresa/${idUsuarioEmpresa}/data/${data}`;
  if(id){
    url = url + `?fechamento=${id}`;
  }
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_FECHAMENTO_CAIXA,
        payload: response

      })
  );
}
